import React from 'react';

import MilanoteLogo from '../../icons/MilanoteLogo';
import Icon from '../../icons/Icon';
import BoardIcon from '../../../element/board/boardIcon/BoardIcon';

import { getRootBoardProperty, getColor, getIcon } from '../../../../common/elements/utils/elementPropertyUtils';

import { isTemplateCollectionBoard } from '../../../../common/templates/templateUtil';

import { MNElement } from '../../../../common/elements/elementModelTypes';

type ListItemBoardIconProps = {
    element: MNElement;
    gridSize: number;
    size?: number;
    isAlias?: boolean;
    isShared?: boolean;
    isSelected?: boolean;
};

const ListItemBoardIcon = ({
    element,
    gridSize,
    size = 5,
    isAlias,
    isShared,
    isSelected,
}: ListItemBoardIconProps): React.ReactElement => {
    let iconComponent;

    if (getRootBoardProperty(element)) {
        const areaSize = gridSize * size;
        const logoSize = Math.round((areaSize / 32) * 13);

        iconComponent = <MilanoteLogo size={gridSize * size} logoSize={logoSize} strokeWidth={2} animate={false} />;
    } else if (isTemplateCollectionBoard(element)) {
        iconComponent = <Icon name="old-notification-template" />;
    } else {
        iconComponent = (
            <BoardIcon
                element={element}
                icon={getIcon(element)}
                color={getColor(element)}
                size={size}
                isAlias={isAlias}
                isShared={isShared}
                isSelected={isSelected}
            />
        );
    }

    return <div className="ListItemBoardIcon">{iconComponent}</div>;
};

export default ListItemBoardIcon;
